var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.1447L31 18V4L21 11.1447Z",
    fill: "#F99F1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4V18L10 11.1447L0 4Z",
    fill: "#F99F1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1136 0H1.88645C0.915998 0 0.145859 0.792527 0 1.81301L15.5 13L31 1.81301C30.8541 0.792527 30.084 0 29.1136 0Z",
    fill: "#F99F1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7875 13.0019L16.035 14.7439C15.8715 14.8467 15.6867 14.8972 15.5 14.8972C15.3133 14.8972 15.1285 14.8467 14.965 14.7439L12.2125 13L0 20.4224C0.149787 21.3103 0.916227 22 1.88303 22H29.117C30.0838 22 30.8502 21.3103 31 20.4224L18.7875 13.0019Z",
    fill: "#F99F1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cec97b06.svg";
export { ForwardRef as ReactComponent };